export default __webpack_public_path__ + "static/media/12 SIN SENTIDO.ab86399e.png";